export function addToCart(products: {
    label: string;
    qty: number;
    designData?: string;
}[]) {
    // eslint-disable-next-line no-console
    console.log(products);
    window.postMessage({
        target: 'projectLists',
        products: products.map(({ label, qty, designData }) => ({
            productCode: label,
            productName: label,
            qty,
            ...(designData ? { designData } : {}),
        })),
    }, '*');
}
